import {
    getEmailMode,
    getSentEmails,
    clearSentEmails,
    getEmailStats,
} from '@/api/email.js';

export default {
    state: {
        emailMode: null,
        isTestingMode: false,
        sentEmails: [],
        emailStats: null,
        isShowEmailView: false,
        testEmailsAvailable: false,
    },
    getters: {
        EMAIL_MODE: (state) => state.emailMode,
        IS_TESTING_MODE: (state) => state.isTestingMode,
        SENT_EMAILS: (state) => state.sentEmails,
        EMAIL_STATS: (state) => state.emailStats,
        IS_SHOW_EMAIL_VIEW: (state) => state.isShowEmailView,
        // True when test-email inspection is available (mock mode OR dual mode)
        IS_TEST_EMAILS_AVAILABLE: (state) => state.testEmailsAvailable,
    },
    mutations: {
        EMAIL_MODE: (state, payload) => {
            state.emailMode = payload;
            state.isTestingMode = payload && !payload.email_sending_enabled;
            // Available when not sending real emails OR when dual storage is on
            state.testEmailsAvailable =
                payload &&
                (!payload.email_sending_enabled || payload.test_storage_enabled);
        },
        SENT_EMAILS: (state, payload) => {
            state.sentEmails = payload;
        },
        EMAIL_STATS: (state, payload) => {
            state.emailStats = payload;
        },
        IS_SHOW_EMAIL_VIEW: (state, payload) => {
            state.isShowEmailView = payload;
        },
    },
    actions: {
        async CHECK_EMAIL_MODE({ commit }) {
            const response = await getEmailMode();
            if (response) {
                commit('EMAIL_MODE', response);
            }
            return response;
        },
        async LOAD_EMAIL_MODE({ commit }) {
            const response = await getEmailMode();
            if (response) {
                commit('EMAIL_MODE', response);
            }
            return response;
        },
        async LOAD_SENT_EMAILS({ commit }) {
            const response = await getSentEmails();
            // Extract just the emails array from the paginated response
            const emails = response && response.emails ? response.emails : [];
            commit('SENT_EMAILS', emails);
            return emails;
        },
        async CLEAR_SENT_EMAILS({ commit, dispatch }) {
            const success = await clearSentEmails();
            if (success) {
                await dispatch('LOAD_SENT_EMAILS');
                return true;
            }
            return false;
        },
        async LOAD_EMAIL_STATS({ commit }) {
            const stats = await getEmailStats();
            // Transform the stats to match what the component expects
            const transformedStats = stats
                ? {
                      total_emails: stats.total_emails || stats.total || 0,
                      unique_recipients:
                          stats.unique_recipients ||
                          Object.keys(stats.recipients || {}).length ||
                          0,
                  }
                : null;
            commit('EMAIL_STATS', transformedStats);
            return transformedStats;
        },
    },
};
